'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _Erc20Token2 = require('./Erc20Token');

var _Erc20Token3 = _interopRequireDefault(_Erc20Token2);

var _Currency = require('../Currency');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PethToken = function (_Erc20Token) {
  (0, _inherits3.default)(PethToken, _Erc20Token);

  function PethToken(contract, web3Service, tub) {
    (0, _classCallCheck3.default)(this, PethToken);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PethToken.__proto__ || (0, _getPrototypeOf2.default)(PethToken)).call(this, contract, web3Service, 18, 'PETH'));

    _this._tub = tub;
    return _this;
  }

  (0, _createClass3.default)(PethToken, [{
    key: 'join',
    value: function join(amount) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref$unit = _ref.unit,
          unit = _ref$unit === undefined ? _Currency.WETH : _ref$unit,
          promise = _ref.promise;

      var value = this._valueForContract(amount, unit);
      return this._tub.join(value, { promise: promise });
    }
  }, {
    key: 'exit',
    value: function exit(amount) {
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref2$unit = _ref2.unit,
          unit = _ref2$unit === undefined ? _Currency.WETH : _ref2$unit,
          promise = _ref2.promise;

      var value = this._valueForContract(amount, unit);
      return this._tub.exit(value, { promise: promise });
    }
  }, {
    key: 'wrapperRatio',
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.t0 = _Currency.WETH;
                _context.next = 3;
                return this._tub.per();

              case 3:
                _context.t1 = _context.sent;
                return _context.abrupt('return', _context.t0.ray.call(_context.t0, _context.t1));

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function wrapperRatio() {
        return _ref3.apply(this, arguments);
      }

      return wrapperRatio;
    }()
  }, {
    key: 'joinPrice',
    value: function () {
      var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(amount) {
        var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Currency.WETH;
        var value;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                value = this._valueForContract(amount, unit);
                _context2.t0 = _Currency.WETH;
                _context2.next = 4;
                return this._tub.ask(value);

              case 4:
                _context2.t1 = _context2.sent;
                return _context2.abrupt('return', _context2.t0.wei.call(_context2.t0, _context2.t1));

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function joinPrice(_x3) {
        return _ref4.apply(this, arguments);
      }

      return joinPrice;
    }()
  }, {
    key: 'exitPrice',
    value: function () {
      var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(amount) {
        var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Currency.WETH;
        var value;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                value = this._valueForContract(amount, unit);
                _context3.t0 = _Currency.WETH;
                _context3.next = 4;
                return this._tub.bid(value);

              case 4:
                _context3.t1 = _context3.sent;
                return _context3.abrupt('return', _context3.t0.wei.call(_context3.t0, _context3.t1));

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function exitPrice(_x5) {
        return _ref5.apply(this, arguments);
      }

      return exitPrice;
    }()
  }]);
  return PethToken;
}(_Erc20Token3.default);

exports.default = PethToken;